module.exports = __webpack_public_path__ + "static/media/11NEPAD6.8e8b1283.jpg";